import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import colorLib from "@kurkle/color";

const isPatternOrGradient = (value: any) => value instanceof CanvasGradient || value instanceof CanvasPattern;

function fromPalette(value: any) {
	return isPatternOrGradient(value) ? value : colorLib(value);
}

function getHoverColor(value: any) {
	return isPatternOrGradient(value) ? value : colorLib(value).saturate(0.5).darken(0.1).hexString();
}

export function colorToText(color: string | null | undefined): string {
	const v = (color ?? "").trim();
	const m = v.match(/^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/);
	return m?.[1] ? `#${m[1].toLowerCase()}` : "";
}

export function textToColor(text: string | null | undefined): string | null {
	const t = (text ?? "").trim().replace(/^#/, "");
	if (!t) return null;
	const m = t.match(/^([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/);
	if (!m) return null;
	let hex = m[1].toLowerCase();
	if (hex.length === 3)
		hex = hex
			.split("")
			.map((c) => c + c)
			.join("");
	return `#${hex}`;
}

export function hexTextValidator(value: string | null | undefined): ValidationErrors | null {
	const raw = (value ?? "").trim();
	const t = raw.replace(/^#/, "");
	if (!t) return null;
	const ok = /^[0-9a-fA-F]{3}$/.test(t) || /^[0-9a-fA-F]{6}$/.test(t);
	return ok ? null : { invalidHex: true };
}

export const hexTextValidatorFn: ValidatorFn = (ctrl: AbstractControl<string | null>): ValidationErrors | null =>
	hexTextValidator(ctrl?.value);

export default {
	fromPalette,
	getHoverColor,
};
